import type { manage as en } from '@/i18n/locales/en/manage';
import type { Translation } from '@/i18n/types';

export const manage: Translation<typeof en> = {
  backToApp: 'Voltar à aplicação',
  sections: {
    companies: {
      label: 'Empresas',
      items: {
        companies: 'Empresas',
        pilots: 'Pilotos',
      },
    },
    people: {
      label: 'Pessoas',
      items: {
        users: 'Todos os utilizadores',
        linkIdentities: 'Ligar identidades',
        admins: 'Administradores',
      },
    },
    audit: {
      label: 'Auditoria',
      items: {
        audit: 'Registo de auditoria',
      },
    },
    subscriptions: {
      label: 'Subscrições',
      items: {
        config: 'Provider configuration',
        products: 'Produtos e fornecedores',
        userLedger: 'Livro-razão de utilizadores',
      },
    },
    system: {
      label: 'Sistema',
      items: {
        statistics: 'Estado das estatísticas e reconstrução',
        requests: 'Pedidos da API',
      },
    },
    support: {
      label: 'Suporte',
      items: {
        tickets: 'Tickets',
      },
    },
    overview: {
      label: 'Visão geral',
      items: {
        overview: 'KPIs',
      },
    },
  },
  placeholders: {
    statistics: {
      title: 'Estado das estatísticas e reconstrução',
      note: 'O estado das estatísticas e os controlos de reconstrução são um plano à parte — esta entrada de menu reserva o lugar, o ecrã não está construído na fase 1.',
    },
  },
  usersAll: {
    title: 'Todos os utilizadores',
    linkIdentities: 'Ligar identidades',
    empty: 'Ainda não existem identidades.',
    name: 'Nome',
    email: 'E-mail',
    language: 'Idioma',
    login: 'Acesso',
    yes: 'sim',
    no: 'não',
    view: 'Ver',
    rowsLabel: 'os utilizadores',
  },
  linkIdentities: {
    title: 'Ligar identidades duplicadas',
    lead: 'O alias continua a existir, mas passa a apontar para a principal. A menos que sejas administrador da plataforma, uma das duas tem de não ter acesso e a identidade com acesso torna-se a principal — o servidor verifica isto, seja qual for a escolha aqui.',
    candidatesLabel: 'as pessoas que administras',
    needTwo: 'Precisas de pelo menos duas pessoas no teu âmbito para ligar.',
    aliasLabel: 'Alias (esta identidade torna-se o ponteiro)',
    primaryLabel: 'Principal (a identidade que permanece)',
    choose: 'Escolhe…',
    hasLogin: '(tem acesso)',
    noLogin: '(sem acesso)',
    link: 'Ligar',
    cancel: 'Cancelar',
  },
  erase: {
    completedTitle: 'Eliminação concluída',
    completedText:
      'A identidade foi eliminada. O registo de auditoria fica pseudonimizado, não eliminado; as identidades ligadas sobrevivem com o seu ponteiro reposto.',
    departmentsWithoutAdmin: 'Departamentos que ficam sem administrador: {{names}}',
    measurementsNotDeleted:
      'As medições no serviço de ingestão NÃO foram eliminadas — essa capacidade ainda não existe lá. Acompanha isto fora do painel.',
    backToUsers: 'Voltar aos utilizadores',
    title: 'Eliminar esta pessoa',
    lead: 'Isto elimina de forma irreversível e definitiva a identidade {{userId}}: a sua linha de utilizador, adesões, consentimentos e concessões. As identidades ligadas sobrevivem; os dados originados no Gengee permanecem; o registo de auditoria fica pseudonimizado. Escreve {{confirmWord}} para confirmar.',
    confirmWord: 'ELIMINAR',
    confirmationLabel: 'Confirmação',
    erasePermanently: 'Eliminar definitivamente',
    cancel: 'Cancelar',
  },
  requests: {
    title: 'Pedidos da API',
    lead: 'Os pedidos registados pela API de ingestão para uma origem, mais recentes primeiro, opcionalmente limitados a uma janela temporal.',
    filterSource: 'Filtrar por origem',
    sourcePlaceholder: 'id de origem',
    filterFrom: 'De',
    filterTo: 'Até',
    filter: 'Filtrar',
    enterSourceHint: 'Introduz um id de origem para carregar o seu registo de pedidos.',
    empty: 'Nenhum pedido registado para esta origem e janela.',
    when: 'Quando',
    method: 'Método',
    path: 'Caminho',
    status: 'Estado',
    rowsLabel: 'os pedidos',
  },
};
